import type { Step } from '@/components/wizard/Step';

import type { SetupOwnCloudState } from './SetupOwnCloudState';
import { ConnectAppRegistrations } from './connectAppRegistrations';
import { ConnectBackupAccount } from './connectBackupAccount';
import { ConnectSourceAccount } from './connectSourceAccount';
import { ConnectVaultAccount } from './connectVaultAccount';

export const setupOwnCloudFlow: Step<SetupOwnCloudState> = {
  name: 'Configure management access',
  Component: ConnectAppRegistrations,
  nonReturnable: false,
  next: [
    {
      name: 'Set up backup account',
      Component: ConnectBackupAccount,
      next: [
        {
          name: 'Connect vault account',
          Component: ConnectVaultAccount,
          next: [
            {
              name: 'Connect source account',
              Component: ConnectSourceAccount,
            },
          ],
        },
      ],
    },
  ],
};
